import { Injectable } from '@angular/core';
import { TravelOption } from '@models/travelOption';
import { FormDataService } from '@services/form-data/form-data.service';
import { BehaviorSubject, Observable, catchError, tap } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class TravelOptionStateService {
    constructor(private formService: FormDataService) {}
    private readonly travelOptions = new BehaviorSubject<TravelOption[] | null>(null);

    private activeLoading = false;

    public getTravelOptions(): Observable<TravelOption[]> {
        if (this.travelOptions.getValue() == null && this.activeLoading === false)
            return this.formService.getTravelOptions().pipe(
                tap((res) => this.travelOptions.next(res)),
                catchError((error) => {
                    this.activeLoading = false;
                    throw error;
                })
            );

        return this.travelOptions.asObservable();
    }
}
